// src/types/visa-prep-form/index.ts
var ShareCodeStatus = /* @__PURE__ */ ((ShareCodeStatus2) => {
  ShareCodeStatus2["NONE"] = "NONE";
  ShareCodeStatus2["VERIFIED"] = "VERIFIED";
  ShareCodeStatus2["NOT_VERIFIED"] = "NOT_VERIFIED";
  ShareCodeStatus2["EXPIRING_SOON"] = "EXPIRING_SOON";
  ShareCodeStatus2["EXPIRED"] = "EXPIRED";
  return ShareCodeStatus2;
})(ShareCodeStatus || {});

// src/types/index.ts
import {
  InfoState,
  CourseLevel
} from "platform-lib/fe-safe";

export {
  ShareCodeStatus,
  InfoState,
  CourseLevel
};
